<template>
  <div class="container">
    <h1 class="subs-title">{{ id ? 'Update a member' : 'Create a member' }}</h1>
    <div v-if="loading">
      <span class="page-title"> Loading... </span>
    </div>
    <member-form
      v-else
      :schema="schema"
      :initial-values="membership"
      :organization-slug="organizationSlug"
      :submitting="submitting"
      @onCreate="handleCreate"
      @onUpdate="handleUpdate"
    />
  </div>
</template>

<script>
import MemberForm from '@/components/organizations/memberships/forms/MemberForm.vue'
import { GET_ORGANIZATION_BY_SLUG } from '@/graphql/organization.graphql'
import { createAttendeeSchema } from '@/utils'
import {
  CREATE_SPORT_MEMBERSHIP_USER,
  GET_SPORT_MEMBERSHIP_USER,
  UPDATE_SPORT_MEMBERSHIP_USER,
} from '@/graphql/membershipUser.graphql'

export default {
  name: 'member-container',
  components: { MemberForm },
  props: {
    id: {
      type: String,
      default: null,
    },
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      membership: null,
      schema: {},
      loading: true,
      submitting: false,
    }
  },
  async mounted() {
    await this.getOrganization()
    if (this.id) {
      await this.getMembership(this.id)
    }
  },
  methods: {
    async handleCreate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: CREATE_SPORT_MEMBERSHIP_USER,
        variables: {
          dto: this.mapFormData(form),
        },
      })

      this.$router.go(-1)
      this.submitting = false
    },
    async handleUpdate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: UPDATE_SPORT_MEMBERSHIP_USER,
        variables: {
          id: this.id,
          dto: this.mapFormData(form),
        },
      })

      this.$router.go(-1)
      this.submitting = false
    },
    async getMembership(id) {
      this.loading = true
      const { data } = await this.$apollo.query({
        query: GET_SPORT_MEMBERSHIP_USER,
        variables: { id, organizationSlug: this.organizationSlug },
      })

      this.membership = data.getMembershipUserById
      this.loading = false
    },
    async getOrganization() {
      const { data } = await this.$apollo.query({
        query: GET_ORGANIZATION_BY_SLUG,
        variables: { organizationSlug: this.organizationSlug },
      })

      if (data) {
        this.organization = data.getOrganizationBySlug
        if (this.organization.attendeeFields.membershipFields) {
          this.schema = createAttendeeSchema(this.organization.attendeeFields.membershipFields)
        }
      }

      this.loading = false
    },
    mapFormData(data) {
      let payload = {
        fields: {},
      }

      Object.keys(data).forEach(key => {
        if (key === 'membershipPlanId') {
          Object.assign(payload, { [key]: parseInt(data[key]) })
        } else {
          Object.assign(payload.fields, { [key]: data[key] })
        }
      })

      return payload
    },
  },
}
</script>
<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
  row-gap: 2rem;
}

.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
